import { Badge } from "@/components/ui/badge";
import { usePrices } from "@/contexts/prices-provider";
import { TeamUserRolesEnum } from "@/enums/team-user-role";
import { useTranslation } from "@/hooks/useTranslation";
import { formatDateNumeric } from "@/lib/format-amount";
import { AdminTeamUserDTO, TeamBillingPriceDTO } from "@shaarp/common";
import { useEffect, useState } from "react";

export default function DataTableCellAdminTeamUserLicence({
  user,
}: {
  user: AdminTeamUserDTO;
}) {
  const { prices, apiFetchPrices } = usePrices();
  const { t, i18n } = useTranslation();

  const [priceSelected, setPriceSelected] = useState<TeamBillingPriceDTO>();
  useEffect(() => {
    const init = async () => {
      await apiFetchPrices();
    };
    init();
  }, []);

  useEffect(() => {
    if (user.priceId && prices.length) {
      const price = prices.find((price) => price.id === user.priceId);
      setPriceSelected(price);
    }
  }, [prices]);

  // Shaarp staff always surface with the team's "admin" role and get full Pro
  // access without consuming a seat, so their licence is fixed to Pro.
  if (user.role === TeamUserRolesEnum.ADMIN) {
    return (
      <>
        {prices.find((price) => price.licenceType === "professional")
          ?.productName ?? t("admin.dataTableAdminTeamUsers.licence.proPlan")}
      </>
    );
  }

  if (user.role === TeamUserRolesEnum.BILLING) {
    return null;
  }

  return (
    <div className="flex flex-col items-start gap-1">
      <span>
        {priceSelected
          ? `${priceSelected.productName} (${priceSelected.interval === "year" ? t("admin.dataTableAdminTeamUsers.licence.annual") : t("admin.dataTableAdminTeamUsers.licence.monthly")})`
          : ""}
      </span>
      {user.scheduledUnassignAt && (
        <Badge variant="destructive">
          {t("admin.dataTableAdminTeamUsers.licence.scheduledRemoval", {
            date: formatDateNumeric(user.scheduledUnassignAt, i18n.language),
          })}
        </Badge>
      )}
    </div>
  );
}
